import React from 'react'
import Svg, { Defs, G, Path, SvgProps } from 'react-native-svg'

const RewardsIcon: React.FC<SvgProps> = ({ width = 32, height = 32 }) => (
  <Svg width={width} height={height} viewBox="0 0 32 32">
    <Defs>
      <linearGradient id="a" x1=".185" x2=".825" y1="1" gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#6000ff" />
        <stop offset="1" stopColor="#ae60ff" />
      </linearGradient>
    </Defs>
    <G>
      <Path
        fill="url(#a)"
        d="M12.993 2.348C13.027 1.236 13 .041 13 0H2.693c0 .041-.03 1.236 0 2.348H0a12.915 12.915 0 0 0 .793 5.219 7.184 7.184 0 0 0 2.217 2.9 25.707 25.707 0 0 0 3.94 2.369V14c-.174.412-.888 1.162-3.146 1.162h-.782v1.978h9.668v-1.977h-.97c-2.293 0-2.833-.787-2.957-1.162v-1.165a41.237 41.237 0 0 0 3.943-2.369 8.385 8.385 0 0 0 2.217-2.9 15.821 15.821 0 0 0 .789-5.223ZM2.327 6.752A7.287 7.287 0 0 1 1.734 4.2h1.084c.026.247.053.465.087.671a19.568 19.568 0 0 0 .971 3.975 5.844 5.844 0 0 1-1.549-2.094Zm11.059 0a5.88 5.88 0 0 1-1.571 2.113 19.293 19.293 0 0 0 .974-3.992c.03-.206.06-.424.087-.671h1.107a7.286 7.286 0 0 1-.598 2.55Z"
        transform="translate(8.145 8.86)"
      />
      <Path
        fill="#ffbc00"
        d="M17.018 15.44a1.587 1.587 0 0 0 1.076-.457 1.382 1.382 0 0 0 .444-1.023 1.376 1.376 0 0 0 .437 1.023 1.587 1.587 0 0 0 1.076.457 1.587 1.587 0 0 0-1.076.457 1.376 1.376 0 0 0-.437 1.027 1.359 1.359 0 0 0-.444-1.023 1.587 1.587 0 0 0-1.076-.461Zm.595-6.548a3.1 3.1 0 0 0 2.094-.895 2.692 2.692 0 0 0 .861-2 2.692 2.692 0 0 0 .861 2 3.126 3.126 0 0 0 2.1.895 3.179 3.179 0 0 0-1.493.432 3.025 3.025 0 0 0-1.08 1.053 2.714 2.714 0 0 0-.391 1.419 2.705 2.705 0 0 0-.861-2 3.074 3.074 0 0 0-2.091-.904Zm-3.787 3.418a2.3 2.3 0 0 0 1.572-.67 2.022 2.022 0 0 0 .639-1.51 2.025 2.025 0 0 0 .646 1.5 2.319 2.319 0 0 0 1.579.67 2.319 2.319 0 0 0-1.579.67 2.025 2.025 0 0 0-.646 1.5 2.043 2.043 0 0 0-.639-1.5 2.325 2.325 0 0 0-1.572-.66Z"
      />
    </G>
  </Svg>
)

export default React.memo(RewardsIcon)
